import "../../../../content/departments/media/global-lead-generation.css";
import * as React from 'react';
export default {
  React
};